<template>
	<div
		class="d-flex justify-sm-center"
		:class="{ 'justify-space-around': !left, 'justify-lg-end': left }"
	>
		<span v-if="text" class="result-text">{{ text }}</span>
		<div v-if="single" class="result-digit single">
			<img :src="fieryBalls[parseInt(value, 10)]" :alt="value" />
		</div>
		<div
			v-else
			class="result-digit"
			v-for="(digit, index) in value"
			:key="index"
		>
			<v-img width="35" height="35" contain :src="fieryBalls[parseInt(digit, 10)]" :alt="digit" />
		</div>
	</div>
</template>

<script>
import chunk from 'lodash/chunk.js';
import fiery0 from 'assets/static/img/balls/hotpicklotto/ball_0_transparent.png';
import fiery1 from 'assets/static/img/balls/hotpicklotto/ball_1_transparent.png';
import fiery2 from 'assets/static/img/balls/hotpicklotto/ball_2_transparent.png';
import fiery3 from 'assets/static/img/balls/hotpicklotto/ball_3_transparent.png';
import fiery4 from 'assets/static/img/balls/hotpicklotto/ball_4_transparent.png';
import fiery5 from 'assets/static/img/balls/hotpicklotto/ball_5_transparent.png';
import fiery6 from 'assets/static/img/balls/hotpicklotto/ball_6_transparent.png';
import fiery7 from 'assets/static/img/balls/hotpicklotto/ball_7_transparent.png';
import fiery8 from 'assets/static/img/balls/hotpicklotto/ball_8_transparent.png';
import fiery9 from 'assets/static/img/balls/hotpicklotto/ball_9_transparent.png';

export default {
	name: 'ResultDigitDisplay',
	props: {
		single: {
			type: Boolean,
			default: false
		},
		value: {
			type: String,
			required: true
		},
		group: {
			type: Number,
			default: null
		},
		text: {
			type: String,
			default: ''
		},
		left: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			fieryBalls: [
				fiery0,
				fiery1,
				fiery2,
				fiery3,
				fiery4,
				fiery5,
				fiery6,
				fiery7,
				fiery8,
				fiery9
			]
		};
	},
	methods: {
		chunk
	},
	computed: {
		computedValue() {
			if (this.group) {
				return chunk(this.value.split(''), this.group);
			} else {
				return this.value;
			}
		}
	}
};
</script>

<style scoped lang="scss">
@import 'css/variables';

.result-digit {
	display: flex;
	margin: 0 2px;

	&.single {
		height: 40px;
		width: 40px;
	}
}

.result-text {
	color: black;
	border-bottom: black 5px solid;
	font-size: 21px;
	margin-right: 5px;
	width: 60px;
	margin-bottom: 20px;
}
</style>
